import React from "react";

type ColourContextType = {
  key: string;
  set: (key: string) => void;
};

const ColourContext = React.createContext<ColourContextType>({
  key: "cyan",
  set: () => {},
});

export default ColourContext;
